<template>
  <div>
    <v-dialog v-model="addCertDialog" width="1100" scrollable persistent>
      <v-card>
        <v-card-title style="font-size: 20px; height: 70px">
          <p>
            <v-icon class="ma-1" style="font-size: 28px; color: #424242"
              >mdi-plus-box-outline</v-icon
            >
            {{ $t(dialog_title) }}
          </p>

          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="CancelCert()"
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
              margin-bottom: 16px;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 700px">
          <v-form ref="form2" v-model="valid_form" lazy-validation>
            <!-- first page  -->
            <div v-if="AddCertPage == 1">
              <v-row class="mt-3">
                <v-col cols="12" lg="12">
                  <p style="color: #424242; font-size: 16px">
                    {{ $t("createdateM") }}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{ this.createdate }} {{ $t("By") }} {{ this.createdBy }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <label for="title" class="font-style">
                    {{ $t("title") }}
                    <span style="color: red">*</span>
                  </label>
                  <v-text-field
                    :rules="titleRules"
                    outlined
                    dense
                    hide-details="auto"
                    v-model="certificate.title"
                    class="mt-2"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <label for="title" class="font-style">
                    {{ $t("description") }}
                  </label>
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    v-model="certificate.description"
                    class="mt-2"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <label
                    for="title"
                    class="font-style"
                    style="font-weight: bold"
                  >
                    {{ $t("choosetemplate") }}
                  </label>
                </v-col>
              </v-row>

              <v-row class="mr-5 ml-5">
                <v-col
                  cols="12"
                  xs="12"
                  sm="4"
                  md="4"
                  lg="4"
                  v-for="(item, i) in templateItems"
                  :key="i"
                >
                  <div class="drop">
                    <v-card
                      @click="ToOpenFile(item)"
                      @dragover.prevent
                      @dragenter.prevent
                      @drop.prevent="dropImg($event)"
                      class="scaled-container"
                    >
                      <v-img
                        v-if="item.templateImage"
                        :src="item.templateImage"
                        @mouseover="
                          item.templateImage
                            ? (item.showEditImgTool = true)
                            : (item.showEditImgTool = false)
                        "
                        @mouseleave="
                          item.templateImage
                            ? (item.showEditImgTool = false)
                            : (item.showEditImgTool = false)
                        "
                        width="300"
                        height="167"
                        class="mx-auto center"
                        contain
                      >
                        <v-card-title v-if="item.showEditImgTool">
                          <v-list
                            class="d-flex flex-column align-start"
                            style="
                              padding: 0;
                              border-radius: 8px !important;
                              box-shadow: 0 0 7px 5px rgba(0, 0, 0, 0.2) !important;
                            "
                          >
                            <v-list-item class="list-item-padding">
                              <v-btn
                                color="#424242"
                                style="font-size: 14px; min-width: 100px"
                                text
                                class="text-capitalize"
                                @click.stop="
                                  (previewimg = true),
                                    (previewImage = item.templateImage)
                                "
                              >
                                <v-icon left>mdi-eye-outline</v-icon>
                                {{ $t("preview") }}
                              </v-btn>
                            </v-list-item>
                            <v-list-item
                              class="list-item-padding"
                              v-show="item.id == 0"
                            >
                              <v-btn
                                color="error"
                                style="font-size: 14px; width: 100px"
                                text
                                class="text-capitalize"
                                @click.stop="item.templateImage = null"
                              >
                                <v-icon left>mdi-delete-outline</v-icon>
                                {{ $t("delete") }}
                              </v-btn>
                            </v-list-item>
                          </v-list>
                        </v-card-title>
                      </v-img>

                      <label
                        v-else
                        for="title"
                        class="font-style center"
                        style="
                          font-weight: bold;
                          text-align: center;
                          display: block;
                        "
                      >
                        {{ $t("selectfile") }}
                      </label>
                    </v-card>
                    <v-radio-group
                      v-model="certificate.checkTemplate"
                      style="margin: 0%"
                    >
                      <v-radio
                        :value="item.id"
                        color="#a6cc39"
                        hide-details
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
              </v-row>
              <v-row class="ml-5" v-show="fileError">
                <label
                  for="title"
                  class="font-style"
                  style="font-weight: bold; color: #fa5252"
                >
                  {{ $t("selectcertificatetemplate") }}
                </label>
              </v-row>
            </div>
            <!-- second page -->

            <ReviseCertificate
              v-if="AddCertPage == 2"
              :selected_certificate="selectedTemp"
              :draggable_fields="draggable_fields"
              ref="childComponent"
            />

            <!-- third page -->
            <!-- <div v-if="AddCertPage == 3" class="px-2">
              <v-row class="mt-3 pl-8 pt-3">
                <label
                  for="title"
                  class="font-style"
                  style="font-weight: bold; font-size: 18px"
                >
                  {{ $t("setupsendingcert") }}
                </label>
              </v-row>
              <v-row class="pl-8">
                <v-radio-group v-model="certificate.emailFormat">
                  <v-radio
                    :label="$t('sendemailautomatically')"
                    :value="1"
                  ></v-radio>
                  <v-card
                    flat
                    width="650"
                    class="ml-10 mt-3 pa-4"
                    style="
                      background: #f8f8f8 0% 0% no-repeat padding-box;
                      border-radius: 0px !important;
                    "
                  >
                    <v-row class="ml-5">
                      <label
                        for="title"
                        class="font-style"
                        style="font-weight: bold; margin-top: 10px"
                      >
                        {{ $t("conditionsforautomatic") }}
                      </label>
                    </v-row>
                    <v-row class="ml-5 mt-5 mb-5">
                      <label
                        for="title"
                        class="font-style ml-5"
                        style="text-indent: 10%"
                      >
                        {{ $t("usersmustcomplete") }}
                      </label>
                    </v-row>
                  </v-card>
                  <v-radio
                    :label="$t('sendemailmanually')"
                    :value="2"
                    class="mt-5"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </div> -->
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="my-2">
          <v-spacer></v-spacer>
          <v-btn
            text
            outlined
            width="100"
            class="text-capitalize mr-3"
            @click="CancelCert()"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="text-capitalize"
            width="100"
            color="secondary"
            @click="ClickNext()"
            :disabled="AddCertPage == 2 ? disabledNextBtn : false"
            v-if="AddCertPage == 1"
          >
            <!-- temporary hide || AddCertPage == 2 -->
            {{ $t("next") }}
          </v-btn>
          <v-btn
            class="text-capitalize"
            width="100"
            color="secondary"
            @click="update_certificatePositions()"
            v-else
          >
            {{ addCertificate ? $t("save") : $t("update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <input
      type="file"
      class="d-none"
      ref="filetemplate"
      accept="image/*"
      @change="uploadTemplate($event, 1)"
    />

    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="800px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          contain
          style="border-radius: 8px; margin: auto"
          :src="previewImage"
        ></v-img>
      </v-card>
    </v-dialog>

    <!-- Loading -->
    <v-dialog v-model="showLoading" persistent width="300">
      <v-card color="#4caf50" dark class="py-1">
        <v-card-text class="white--text">
          {{ $t("loadingpleasewait") }}
          <v-progress-linear
            indeterminate
            color="#ffffff"
            class="mb-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment/moment";
import ReviseCertificate from "./ReviseCertificate.vue";
import certificateJS from "./certificate.js";

export default {
  components: {
    ReviseCertificate,
  },
  props: {
    show_dialog: {
      type: Boolean,
      default: false,
    },
    q_Item: {
      type: Object,
      default: null,
    },
    dialog_title: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    disabledNextBtn: false,
    draggable_fields: [
      {
        text: "image",
        type: "stamp_Img",
        width: "20",
        icon: require("@/assets/images/Stamp.svg"),
        disabled: false,
        placeholder: "",
      },
      {
        text: "fullnamesm",
        type: "full-name",
        width: "24",
        icon: require("@/assets/images/Pen.svg"),
        disabled: false,
        placeholder: "fullnamesm",
      },
      {
        text: "textbox",
        type: "text",
        width: "24",
        icon: require("@/assets/images/text_A.svg"),
        disabled: false,
        placeholder: "enter-text",
      },
      {
        text: "date-stamp",
        type: "date",
        width: "20",
        icon: require("@/assets/images/calendar.svg"),
        disabled: false,
        placeholder: "",
      },
      {
        text: "course-name",
        type: "course-name",
        width: "24",
        icon: require("@/assets/images/pen_2.svg"),
        disabled: false,
        placeholder: "",
      },
    ],
    addCertificate: null,
    edit_elementItem: [],
    showLoading: false,
    selectedTemp: null,
    valid_form: true,
    //createdBy: null,
    createdate: moment(new Date().toISOString().substr(0, 10))
      .local()
      .format("DD MMM YYYY"),
    certificate: {
      fileName: null, // remove or not
      checkTemplate: null, // stroe template id
      title: null,
      description: null,
      templateImage: null,
      templatePDF: null,
      quizID: null,
      courseID: 0,
      emailFormat: 0,
      createBy: "",
      width: 0,
      height: 0,
      certTemplateMasterID: 0,
      plainTemplate: null,
      status: null,
      certificatePositions: [],
      emailAutoSend: false,
    },
    templateItems: [],
    // showEditImgTool: false,
    fileError: false,
    previewimg: false,
    previewImage: "",
    AddCertPage: 1,
    selectFileTemplate: [
      {
        id: 0,
        templateImage: "",
        activeFlag: true,
        showEditImgTool: false,
      },
    ],
  }),

  computed: {
    addCertDialog: {
      get() {
        return this.show_dialog;
      },
      set() {
        this.$emit("close_dialog");
      },
    },
    titleRules() {
      return [(v) => !!v || "Title is required"];
    },
    createdBy: {
      get() {
        return this.q_Item.create_by;
      },
    },
  },
  watch: {
    addCertDialog(val) {
      if (val) {
        this.GetDefaultTemplate();
      }
    },
  },

  mounted() {
    this.$emit("close_dialog");
  },

  methods: {
    insertDataToEdit() {
      let copy_cert = this.q_Item.certificate_Item;

      this.certificate = {
        certificateID: copy_cert.certificateID,
        title: copy_cert.title,
        description: copy_cert.description,
        templateImage: copy_cert.templateImage,
        templatePDF: copy_cert.templatePDF,
        quizID: copy_cert.quizID,
        courseID: copy_cert.courseID,
        status: copy_cert.status,
        emailFormat: 2, // copy_cert.emailFormat,
        emailAutoSend: copy_cert.emailAutoSend,
        width: copy_cert.width,
        height: copy_cert.height,
        plainTemplate: copy_cert.plainTemplate,
        certificatePositions: [],
        checkTemplate: copy_cert.certTemplateMasterID,
        createBy: copy_cert.createBy,
      };

      if (copy_cert.certTemplateMasterID == 0) {
        this.selectedTemp = copy_cert.plainTemplate;
      } else {
        this.selectedTemp =
          this.templateItems.find(x => x.id === copy_cert.certTemplateMasterID).templateImage;
      }
      this.edit_elementItem = copy_cert.certificatePositions;
      //...store elements in vuex....
      this.$store.commit("saveCertElementsToEdit", this.edit_elementItem);

      if (this.q_Item.course_name === null) {
        this.draggable_fields[4].disabled = true;
      } else {
        this.draggable_fields[4].placeholder = this.q_Item.course_name;
      }
      this.AddCertPage = 2;
    },

    async SaveCertificateAndSendMail() {
      this.showLoading = true;

      let imagedata = "";
      if (this.certificate.checkTemplate == 0) {
        const base64Res = await this.$axios.post(
          `${this.web_url}File/UploadFileStringBase`,
          {
            base64: this.templateItems[0].templateImage,
            fileName: this.certificate.fileName,
          }
        );
        imagedata = base64Res.data;
      }
      let plain_temp = certificateJS.removeToken(this.selectedTemp);

      let request = {
        certificateID: 0,
        title: this.certificate.title,
        description: this.certificate.description,
        templateImage: this.certificate.templateImage,
        templatePDF: this.certificate.templatePDF,
        quizID: localStorage.getItem("QuizId"),
        courseID: this.q_Item.courseId,
        status: true,
        certTemplateMasterID: this.certificate.checkTemplate,
        emailFormat: 2, // that.certificate.emailFormat,
        emailAutoSend: false,
        createBy: this.q_Item.memberid,
        width: this.certificate.width,
        height: this.certificate.height,
        plainTemplate:
          this.certificate.checkTemplate == 0 ? imagedata : plain_temp, // certificate bg template...
        certificatePositions: this.certificate.certificatePositions,
      };
      await axios
        .post(`${this.web_url}Certificate/AddCertificate`, request)
        .then((res) => {
          if (res.data.status == 0) {
            this.CancelCert();
            this.showLoading = false;
            this.selectFileTemplate = [
              {
                id: 0,
                templateImage: "",
                activeFlag: true,
                showEditImgTool: false,
              },
            ];
            this.templateItems = [];
          }
        });
    },

    async updateCertificateAndSendMail() {
      this.showLoading = true;
      let plain_temp = certificateJS.removeToken(
        this.certificate.plainTemplate
      );

      let request = {
        certificateID: this.certificate.certificateID,
        title: this.certificate.title,
        description: this.certificate.description,
        templateImage: this.certificate.templateImage,
        templatePDF: this.certificate.templatePDF,
        quizID: this.certificate.quizID,
        courseID: this.certificate.courseID,
        status: this.certificate.status,
        certTemplateMasterID: this.certificate.checkTemplate,
        emailFormat: 2, // that.certificate.emailFormat,
        emailAutoSend: this.certificate.emailAutoSend,
        createBy: this.certificate.createdBy,
        width: this.certificate.width,
        height: this.certificate.height,
        plainTemplate: plain_temp, // that.certificate.plainTemplate, // certificate bg template...
        certificatePositions: this.certificate.certificatePositions,
      };
      await axios
        .post(`${this.web_url}Certificate/UpdateCertificate`, request)
        .then((res) => {
          if (res.data.status == 0) {
            this.CancelCert();
            this.showLoading = false;
            this.selectFileTemplate = [
              {
                id: 0,
                templateImage: "",
                activeFlag: true,
                showEditImgTool: false,
              },
            ];
            this.templateItems = [];
          }
        });
    },

    CancelCert() {
      //this.addCertDialog = false;
      this.AddCertPage = 1;
      this.certificate.title = null;
      this.certificate.description = null;
      this.certificate.fileName = null;
      this.certificate.checkTemplate = null;
      this.certificate.emailFormat = 0;
      this.certificate.emailAutoSend = false;
      this.fileError = false;
      this.selectFileTemplate = [
        {
          id: 0,
          templateImage: "",
          activeFlag: true,
          showEditImgTool: false,
        }
      ];
      this.$store.commit("removeCertElementsData");
      this.$emit("close_dialog");
    },

    async GetDefaultTemplate() {
      this.showLoading = true;
      await axios
        .get(`${this.web_url}Certificate/GetTemplateImageMaster`)
        .then((response) => {

          const res_temp = response.data.data.map((x) => ({
            ...x,
            showEditImgTool: false,
          }));
          if (response.data.status == 0) {
            this.templateItems = [...this.selectFileTemplate, ...res_temp];

            this.showLoading = false;

            if (this.q_Item.type == 1) {
              this.AddCertPage = 1;
              this.addCertificate = true;
            } else {
              this.insertDataToEdit();
              this.addCertificate = false;
            }
          }
        });
    },

    change_to_Percentage(item_val, container_val) {
      let result = (item_val / container_val) * 100;
      return result;
    },

    ClickNext() {
      var templateID = this.certificate.checkTemplate;

      if (this.AddCertPage === 1) {
        if (this.$refs.form2.validate()) {
          if (this.certificate.checkTemplate == null) {
            this.fileError = true;
          } else if (
            (this.certificate.checkTemplate == 0 &&
              this.templateItems[0].templateImage == "") ||
            this.templateItems[0].templateImage == null
          ) {
            // check whether only the radio is select but not attach picture
            this.fileError = false;
            alert("Please attach a certificate template!");
          } else {
            if (this.q_Item.course_name === null) {
              this.draggable_fields[4].disabled = true;
            } else {
              this.draggable_fields[4].placeholder = this.q_Item.course_name;
            }
            this.AddCertPage = 2;
            //that.selectedTemp = that.templateItems[index].templateImage;
            this.selectedTemp = this.templateItems.find(x => x.id === templateID)?.templateImage;

          }
        } else if (
            this.certificate.checkTemplate == null ||
            this.certificate.title == null ||
            this.certificate.title == ""
          ) {
            this.fileError = true;
          } else if (
            this.certificate.checkTemplate == 0 &&
            this.templateItems[0].templateImage == ""
          ) {
            alert("Please attach a certificate template!");
          } else {
            this.AddCertPage = 2;
            this.selectedTemp = this.templateItems.find(x => x.id === templateID)?.templateImage;

          }
      }
      // temporary hide
      // else if (that.AddCertPage === 2) {
      //   that.disabledNextBtn = true;
      //   that.showLoading = true;
      //   that.update_certificatePositions();
      // }
    },

    async update_certificatePositions() {
      this.showLoading = true;
      this.disabledNextBtn = true;
      try {
        await Promise.all([
          this.$refs.childComponent.clearActiveBeforeCapture(),
          this.$refs.childComponent.captureAsImage(),
          //that.$refs.childComponent.captureAsPDF(),
          this.$refs.childComponent.uploadImgtoSave(),
          this.$refs.childComponent.getContainerDimensions(),
        ]);

        const items = this.$refs.childComponent.elements;
        const imgAndPdfFiles = this.$refs.childComponent.templateObj;
        const c_width = this.$refs.childComponent.imageWidth;
        const c_height = this.$refs.childComponent.imageHeight;

        if (imgAndPdfFiles.image) {
          this.showLoading = false;
          // that.AddCertPage = 3;
          this.disabledNextBtn = false;
        }

        const updated_data = items.map((v) => ({
          //id: v.id,
          certificateID: v.certificateID == 0 ? 0 : v.certificateID, //when add
          x: this.change_to_Percentage(v.x, c_width),
          y: this.change_to_Percentage(v.y, c_height),
          width: this.change_to_Percentage(v.width, c_width), // v.type == "stamp_Img" ?  : v.width,
          height: this.change_to_Percentage(v.height, c_height), // v.type == "stamp_Img" ?  : v.height,
          angle: 0,
          type: v.type,
          text: v.text,
          icon: v.icon,
          inputText: v.showText,
          imgUrl: v.img_blob,
          fontStyle: v.fontStyle,
          fontSize: v.fontSize,
          fontColor: v.fontColor,
          fontBoldItalicUnderline: v.fontBoldItalicUnderline,
        }));

        this.certificate.certificatePositions = updated_data;
        this.certificate.templateImage = imgAndPdfFiles.image;
        this.certificate.templatePDF = imgAndPdfFiles.pdf;
        this.certificate.width = c_width;
        this.certificate.height = c_height;

        if (this.addCertificate) {
          this.SaveCertificateAndSendMail();
        } else {
          this.updateCertificateAndSendMail();
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    getFile(e) {
      this.templateItems[0].templateImage = e;
      this.templateItems[0].showEditImgTool = false;
    },
    ToOpenFile(item) {
      if (item.templateImage == "" || item.templateImage == null) {
        this.$refs.filetemplate.click();
      }
    },

    uploadTemplate(e, num) {
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.certificate.fileName = file.name;
      let reader = new FileReader();
      reader.onload = (f) => {
        let data;
        if (typeof f.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          data = f.target.result;
        }
        if (num === 1) {
          // self.option.img = data;
          // self.dialogCrop = true;
          this.getFile(data);
        }
      };
      //  reader.readAsArrayBuffer(file);
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.font-style {
  color: #000000;
  font-size: 14px;
}
::v-deep .v-dialog > .v-card > .v-card__title {
  padding: 16px 16px 10px;
}
::v-deep .v-dialog > .v-card > .v-card__text {
  padding: 0 16px 10px !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}

.scaled-container {
  width: 300px;
  height: 200px;
  overflow: hidden;
  resize: both;
  border: 2px dashed #c0c0c0;
  box-shadow: unset !important;
  background: #f8f8f8 0% 0% no-repeat padding-box;
  border-radius: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

::v-deep .v-responsive__content {
  margin-left: -100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
::v-deep .v-list {
  border-radius: 8px !important;
}
::v-deep .list-item-padding {
  min-height: unset !important;
  padding: 0 !important;
}
</style>
